<template>
  <div>
    <a-card style="margin-bottom: 1rem;" class="card">
      <div slot="title">
        <a-row>
          <a-col :xs="3" :md="2" :lg="1">
            <a-button
              type="primary"
              size="small"
              icon="left"
              shape="circle"
              class="back-button"
              style="margin-right: 1rem;"
              @click="backButton"
            />
          </a-col>
          <a-col :xs="21" :md="22" :lg="23">
            <a-skeleton
              v-if="loading"
              :paragraph="false"
              :avatar="false"
              :title="{ width: '90%' }"
              active
            />
            <span v-else>
              <span v-if="isAddSubscriber">
                <h3 class="hover-title main-card-title">
                  <a-icon type="user"></a-icon> NUEVO SUSCRIPTO
                </h3>
                <h5 class="btn-edit-subscription">
                  {{ subscription.name }}
                </h5>
              </span>
              <span v-else>
                <h3 class="main-card-title">
                  <a-icon type="user"></a-icon> {{ subscriber.firstName }}
                  {{ subscriber.lastName }}
                </h3>
                <h5 class="btn-edit-subscription">
                  {{ subscription.name }}
                </h5>

                <!--
                <span style="color:#aaa">#{{ subscription.id }}</span
                >&nbsp;{{ subscription.name }} 
                -->
              </span>
            </span>
          </a-col>
        </a-row>

        <!--<a-icon @click="backButton()" type="arrow-left">Volver </a-icon>-->
      </div>
      <a-switch
        slot="extra"
        style="margin-left: 1em;"
        checkedChildren="Activo"
        unCheckedChildren="Inactivo"
        @change="handleStatusSwitch"
        :checked="subscriberActive"
        :disabled="switchDisabled"
        :loading="switchLoader"
      />

      <!-- SOLO SE MUESTRA EN CASO DE VIEW-->
      <span v-if="displayClientInfo && subscription.subscriptionsCustomers">
        <h3
          v-if="
            subscription.subscriptionsCustomers.endDate != null &&
              subscription.subscriptionsCustomers.status != '1' &&
              subscription.subscriptionsCustomers.status != '5'
          "
        >
          <strong>Baja:</strong>
          {{
            subscription.subscriptionsCustomers.endDate | moment("DD/MM/YYYY")
          }}
        </h3>
        <h3 style="margin-bottom: 1.5rem;">
          <a-tag
            v-if="
              (subscription.subscriptionsCustomers.status == '1' ||
                subscription.subscriptionsCustomers.status == '5') &&
                subscription.subscriptionsCustomers.lastFailedDebitAttempt
            "
            color="orange"
            style="font-size: 13px; cursor: default;"
            >Pago pendiente</a-tag
          >
          <a-tag
            v-else-if="subscription.subscriptionsCustomers.status == '1'"
            color="green"
            style="font-size: 13px; cursor: default;"
            >Activo</a-tag
          >

          <a-tag
            v-else-if="subscription.subscriptionsCustomers.status == '5'"
            color="blue"
            style="font-size: 13px; cursor: default;"
            >Período de Prueba</a-tag
          >
          <a-tag v-else color="pink" style="font-size: 13px; cursor: default;"
            >Inactivo</a-tag
          >
          <span
            v-if="subscription.subscriptionsCustomers.status == '5'"
            style="font-size: 13px; color: #aaa;"
          >
            Desde el
            {{
              $moment(subscription.subscriptionsCustomers.startDate)
                | moment("DD/MM/YYYY")
            }}
            hasta el
            {{
              $moment(subscription.subscriptionsCustomers.startDate).add(
                subscription.freeTrialDays,
                "day"
              ) | moment("DD/MM/YYYY")
            }}</span
          >
          <span v-else style="font-size: 13px; color: #aaa;">
            Último período pagado:
            {{
              $moment(subscription.subscriptionsCustomers.lastPeriodPaid)
                | moment("DD/MM/YYYY")
            }}
            al
            {{
              $moment(subscription.subscriptionsCustomers.lastPeriodPaid).add(
                1,
                "month"
              ) | moment("DD/MM/YYYY")
            }}</span
          >
        </h3>
        <h3 v-if="subscriber.phone1">
          <strong>Teléfono:</strong>&nbsp;
          <a :href="'https://wa.me/' + subscriber.phone1" target="_blank"
            ><i class="icmn-whatsapp" />&nbsp;{{ subscriber.phone1 }}</a
          >
        </h3>
        <h3>
          <strong>Email:</strong>
          <a :href="'mailto:' + subscriber.email">
            {{ subscriber.email }}
          </a>
        </h3>
        <h3 style="margin-bottom: 1.5rem;">
          <strong>Inicio de Suscripción:</strong>
          {{
            subscription.subscriptionsCustomers.startDate | moment("DD/MM/YYYY")
          }}
        </h3>
      </span>

      <span ref="subscribeForm">
        <a-form
          class="login-form"
          :form="form"
          @submit="handleSubmit"
          novalidate
        >
          <span v-show="isAddSubscriber">
            <a-divider orientation="left">Cliente</a-divider>
            <a-form-item has-feedback validating="validatingUser">
              <a-input-search
                @blur="searchCustomer"
                @search="searchCustomer"
                @pressEnter="searchCustomer"
                @touchleave="searchCustomer"
                enterButton
                name="email"
                autocomplete="email"
                placeholder="Email (buscar usuario por email)"
                :disabled="emailFieldDisabled"
                v-decorator="[
                  'email',
                  {
                    rules: [
                      {
                        type: 'email',
                        message: 'La dirección de correo es inválida.'
                      },
                      {
                        required: true,
                        message: 'Por favor, ingrese una dirección de correo.'
                      },
                      {
                        validator: (rule, value) => this.isNewCustomer === true,
                        message:
                          'El usuario ya se encuentra registrado a esta suscripción.'
                      }
                    ]
                  }
                ]"
              >
                <span slot="prefix" style="color: rgba(0, 0, 0, 0.25);">@</span>
              </a-input-search>
            </a-form-item>

            <a-form-item style="margin-bottom: 0;">
              <a-form-item
                has-feedback
                :style="{
                  'margin-right': '10px',
                  display: 'inline-block',
                  width: '15rem'
                }"
              >
                <a-input
                  name="fname"
                  autocomplete="given-name"
                  placeholder="Nombre"
                  :disabled="customerFieldsDisabled"
                  ref="firstName"
                  v-decorator="[
                    'firstName',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Por favor, ingrese el nombre.'
                        }
                      ]
                    }
                  ]"
                >
                  <a-icon
                    slot="prefix"
                    type="font-size"
                    style="color: rgba(0, 0, 0, 0.25);"
                  />
                </a-input>
              </a-form-item>

              <a-form-item
                has-feedback
                :style="{ display: 'inline-block', width: '15rem' }"
              >
                <a-input
                  name="lname"
                  autocomplete="family-name"
                  placeholder="Apellido"
                  :disabled="customerFieldsDisabled"
                  @blur="cardNameHelper"
                  v-decorator="[
                    'lastName',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Por favor, ingrese el apellido.'
                        }
                      ]
                    }
                  ]"
                >
                  <a-icon
                    slot="prefix"
                    type="font-size"
                    style="color: rgba(0, 0, 0, 0.25);"
                  />
                </a-input>
              </a-form-item>
            </a-form-item>

            <a-form-item has-feedback>
              <a-input
                name="tel"
                autocomplete="tel"
                placeholder="Tel / Whatsapp (Ej: 11 4939-5005)"
                :disabled="customerFieldsDisabled"
                v-decorator="[
                  'tel',
                  {
                    rules: [
                      {
                        required: false
                      }
                    ]
                  }
                ]"
              >
                <a-select
                  slot="addonBefore"
                  :disabled="customerFieldsDisabled"
                  v-decorator="[
                    'prefix',
                    {
                      initialValue: '+549'
                    }
                  ]"
                  style="width: 86px;"
                >
                  <a-select-option
                    v-for="code in telCountryCodes"
                    :key="code.value"
                    :value="code.value"
                  >
                    {{ code.label }}
                  </a-select-option>
                </a-select>
              </a-input>
            </a-form-item>
          </span>

          <a-divider orientation="left">Medio de Pago</a-divider>

          <h3
            v-if="
              (isAddSubscriber && !displayNewCardForm) ||
                isAddSubscriber == false
            "
          >
            <a-form
              class="login-form"
              :form="form"
              @submit="handleSubmit"
              novalidate
            >
              <a-form-item has-feedback>
                <a-select
                  style="width: 50%;"
                  @change="handleCardSelect"
                  placeholder="Seleccionar Tarjeta"
                  ref="cardSelect"
                  v-decorator="[
                    'customerCards',
                    {
                      //initialValue: defaultCardId,
                      //getValueFromEvent: formatCardNumber,
                      rules: [
                        {
                          required: true,
                          message: 'Por favor, seleccione una opción.'
                        }
                      ]
                    }
                  ]"
                >
                  <a-select-option v-for="item in customerCards" :key="item.id"
                    >{{ item.paymentCourier.name.toUpperCase() }} xxxx xxxx xxxx
                    {{ item.lastFourDigits }} | Exp:
                    {{ item.expirationDate | moment("MM/YY") }}
                  </a-select-option>
                  <a-select-option :key="0">Nueva Tarjeta </a-select-option>
                </a-select>
                <a-tooltip
                  title="Seleccionar la tarjeta que el cliente desea utilizar o 'Nueva' si utilizará una nueva."
                  placement="right"
                  ><a-icon
                    type="question-circle-o"
                    class="tooltip-icon tooltip-top"
                  />
                </a-tooltip>
              </a-form-item>
            </a-form>
          </h3>

          <span v-if="displayNewCardForm">
            <payment-form
              v-if="subscription.account"
              ref="paymentFormComponent"
              :mode="'2-step'"
              :showPrice="false"
              :showInstallments="false"
              :showAgreement="false"
              :subtotal="subscription.amount"
              :publicKey="subscription.account.publicKey"
            />
          </span>

          <div class="form-actions">
            <a-button
              v-if="isAddSubscriber"
              type="primary"
              html-type="submit"
              :class="$style.loginFormButton"
              :loading="submitLoader"
              >Suscribir Cliente</a-button
            >
            <a-button
              v-else-if="!subscriberActive"
              type="primary"
              html-type="submit"
              :class="$style.loginFormButton"
              :loading="submitLoader"
              ref="btnActivateSubmit"
              >Reactivar Suscripción</a-button
            >
            <a-button
              v-else
              type="primary"
              html-type="submit"
              :class="$style.loginFormButton"
              :loading="submitLoader"
              >Guardar</a-button
            >
          </div>
        </a-form>
      </span>
      <a
        href="javascript: void(0);"
        class="btn btn-link edit-subscription-button"
        style="margin-bottom: 0;"
      >
        <i class="icmn-cog mr-1" />
        Editar Suscripción
      </a>
      <div v-if="!isAddSubscriber">
        <a-divider orientation="left">Historial de Pagos</a-divider>
        <transactions-list
          v-if="subscription && subscriber"
          :showHeader="false"
          :subscriptionId="subscription.id"
          :customerId="subscriber.id"
        ></transactions-list>
      </div>
    </a-card>
  </div>
</template>

<script>
//import { data } from "./data.json";
import { mapActions } from "vuex";
import store from "@/store";
import Vue from "vue";
import gateway from "@/services/gateway";
import errors from "@/services/errors";
import TransactionsList from "@/views/Dashboard/Transactions/TransactionsList";
import PaymentForm from "@/components/PaymentForm";
import utils from "@/services/utils";

export default {
  name: "subscriber", //necesita tener un name para que funcione el <keep-alive>
  components: {
    "transactions-list": TransactionsList,
    PaymentForm
  },
  data() {
    return {
      isAddSubscriber: false,
      subscriptionId: null,
      validatingUser: false,
      form: this.$form.createForm(this),
      subscriberId: null,
      isNewCustomer: true, //valida si es un cliente ya suscripto
      emailFieldDisabled: false,
      customerFieldsDisabled: true,
      cardFieldsDisabled: true,
      customerCards: [],
      displayCardSelect: false,
      displayClientInfo: false,
      displayNewCardForm: true,
      cardSelectedId: null,
      defaultCardId: null,
      loading: true,
      submitLoader: false,
      editIcon: false,
      subscriber: null,
      subscriberActive: true,
      switchDisabled: false,
      switchLoader: false,
      subscription: {
        id: null,
        account: null,
        uuid: null,
        name: null,
        amount: null,
        frequencyId: "",
        freeTrialDays: null,
        costCenter: {
          id: null,
          name: null,
          product: { name: null }
        },
        businessUnit: {
          id: null,
          name: null
        },
        product: {
          id: null,
          name: null
        },
        subscriptionsCustomer: null
      },
      linkToken: null,
      telCountryCodes: utils.getTelCountryCodes()
    };
  },
  //props: ["subscriptionId"],
  methods: {
    ...mapActions({
      loadSubscription: "subscriber/load",
      subscribe: "subscriber/subscribe",
      unsubscribe: "subscriber/unsubscribe",
      activate: "subscriber/activate",
      getCustomer: "subscriber/loadCustomer",
      saveCustomer: "subscriber/saveCustomer"
    }),
    backButton() {
      this.$router.push(`/subscriptions/${this.subscription.id}`);
    },
    async handleStatusSwitch(active) {
      try {
        //console.log("params:", params);
        if (!this.switchLoader) {
          this.switchLoader = true;
          if (this.subscriberActive) {
            const result = await this.unsubscribe({
              subscriptionId: this.subscription.id,
              subscriberId: this.subscriberId
            });
            if (result) {
              this.subscriberActive = false;
              this.switchLoader = false;
              this.$notification["success"]({
                message: "Exito",
                description: result
              });
            }
          } else {
            //subscriber inactive
            //this.$refs.subscribeForm.firstChild.submit();
            await this.handleSubmit(); //activate
            //this.$refs.btnActivateSubmit.$children[0].submit();
            this.switchLoader = false;
          }
        }
      } catch (error) {
        this.switchLoader = false;
        this.$notification["warning"]({
          message: error.code,
          description: error.message
        });
      }
    },
    async fetchSubscription() {
      try {
        //console.log("params:", params);
        //const id = this.$router.params.id
        this.loading = true;
        this.subscriptionId = this.$route.params.id;
        const subscription = await this.loadSubscription(this.subscriptionId);
        if (!subscription) throw new Error("Error al buscar la suscripción.");
        this.subscription = subscription;

        //si es un edit cargar customer
        // if (this.isAddSubscriber) {
        //   this.displayNewCardForm = true;
        // } else {
        if (!this.isAddSubscriber) {
          this.displayNewCardForm = false;
          await this.loadCustomer(
            this.$route.params.subscriberId,
            this.subscriptionId
          );
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$notification["warning"]({
          message: error.code,
          description: error.message
        });
      }
    },
    async loadCustomer(subscriberId, subscriptionId) {
      try {
        this.validatingUser = true;
        const customer = await this.getCustomer(subscriberId);

        if (customer) {
          this.subscriber = customer;

          let tel = {
            prefix: null,
            phone: null
          };

          if (customer.phone1) {
            tel = utils.getPrefix(customer.phone1);
          }

          this.form.setFieldsValue({
            email: customer.email,
            firstName: customer.firstName,
            lastName: customer.lastName,
            prefix: tel.prefix,
            tel: tel.phone
          });

          // let tel;
          // if (customer.phone1)
          //   tel =
          //     customer.phone1.indexOf("549") == 0
          //       ? customer.phone1.substr(3)
          //       : customer.phone1;
          // this.form.setFieldsValue({
          //   email: customer.email,
          //   firstName: customer.firstName,
          //   lastName: customer.lastName,
          //   tel
          // });

          //UPDATE: Solo se muestra la actual tarjeta usada en la suscripcion
          //this.customerCards = customer.paymentCards;
          this.customerCards = new Array();

          // for (let card of this.customerCards) {
          //   card.cardTypeName = gateway.getCardType(card.paymentCourierId);
          // }
          const subscription = customer.subscriptions.filter(
            subscription => subscription.id == subscriptionId
          )[0]; //searches for the current subscription in all the subscription of the customer

          if (subscription) {
            this.subscription.subscriptionsCustomers =
              subscription.subscriptionsCustomers;
            //gets the id of the card used for the current subscription and selects it
            //this.handleCardSelect(
            //  subscription.subscriptionsCustomers.paymentCardId
            //);

            //customer.paymentCards;

            const card = customer.paymentCards.find(card => {
              return (
                card.id ==
                this.subscription.subscriptionsCustomers.paymentCardId
              );
            });
            this.customerCards.push(card);

            this.cardSelectedId = card.id;
            this.form.setFieldsValue({
              cardNumber: `xxxx xxxx xxxx ${card.lastFourDigits}`,
              cardType: card.paymentCourier.id,
              cardName: card.ownerName,
              expirationDate: this.$moment(card.expirationDate).format("MM/YY"),
              CVC: "xxx",
              customerCards: subscription.subscriptionsCustomers.paymentCardId
            });
            this.cardFieldsDisabled = true;

            this.form.getFieldDecorator("customerCards", {
              initialValue: subscription.subscriptionsCustomers.paymentCardId
            });
            this.cardSelectedId =
              subscription.subscriptionsCustomers.paymentCardId;
          } else {
            const err = new Error();
            err.message = "El id del cliente es inválido.";
            throw err;
          }

          //LEGACY: para borrar
          // if (customer.paymentCards)
          //   this.cardSelectedId = this.customerCards[0].id;
          //si el cliente no está suscripto pero tiene tarjetas poner la primer tarjeta como default
          //else this.cardSelectedId = null;

          if (
            subscription.subscriptionsCustomers.status == 1 ||
            subscription.subscriptionsCustomers.status == 5
          ) {
            this.subscriberActive = true;
            this.switchDisabled = false;
          } else {
            this.subscriberActive = false;
            //this.switchDisabled = true;
          }

          this.validatingUser = false;
          this.emailFieldDisabled = true;
          this.customerFieldsDisabled = true;
          this.displayCardSelect = true; //muestra el select input de las tarjetas
          this.cardFieldsDisabled = true;
          this.subscriberId = customer.id;

          this.$nextTick(function() {
            this.$refs.cardSelect.$el.children[0].focus();
          });
        } else {
          const err = new Error();
          err.message = "El id del cliente es inválido.";
          throw err;
        }
      } catch (error) {
        this.$notification["warning"]({
          message: error.code,
          description: error.message
        });
      }
    },
    handleCardSelect(val) {
      //nueva tarjeta
      if (val == "0") {
        //seleccionó tarjeta nueva
        // this.form.resetFields([
        //   "cardNumber",
        //   "cardType",
        //   "cardName",
        //   "expirationDate",
        //   "CVC"
        // ]);
        this.displayNewCardForm = true;
        this.cardFieldsDisabled = false;
        this.cardSelectedId = null;
        window.setTimeout(() => {
          this.$nextTick(function() {
            this.$refs.paymentFormComponent.$refs.initial.$el.children[1].focus(); //focus en el número de tarjeta
          });
        }, 300);
      } else {
        const card = this.customerCards.find(card => {
          return card.id == val;
        });
        this.cardSelectedId = card.id;
        this.form.setFieldsValue({
          cardNumber: `xxxx xxxx xxxx ${card.lastFourDigits}`,
          cardType: card.paymentCourier.id,
          cardName: card.ownerName,
          expirationDate: this.$moment(card.expirationDate).format("MM/YY"),
          CVC: "xxx"
        });
        this.cardFieldsDisabled = true;
        //this.handleSubmit();
      }
    },
    validateIsNewSubscriber() {
      return new Error("direccion invalida TEST");
    },
    async searchCustomer(event) {
      try {
        this.validatingUser = true;
        const val = event.target.value;
        if (val.length > 0) {
          const res = await Vue.prototype.$axios.get(
            `/customers/${encodeURIComponent(val)}`
          );
          this.isNewCustomer = true;
          this.form.validateFields(["email"], {
            suppressWarning: true,
            force: true
          });
          if (res.data && !res.data.message) {
            const customer = res.data;

            //si el cliente ya esta subscripto a esta subscrición, dar mensaje de error.
            if (customer.subscriptions.find(c => c.id == this.subscriptionId)) {
              this.isNewCustomer = false;
              this.form.validateFields(["email"], { force: true });
              this.validatingUser = false;
              this.customerFieldsDisabled = true;
              this.displayCardSelect = false;
              this.cardFieldsDisabled = true;
              this.subscriberId = null;
              this.$notification["warning"]({
                message: "Error",
                description: "El cliente ya está subscripto."
              });
            } else {
              let tel = {
                prefix: null,
                phone: null
              };

              if (customer.phone1) {
                tel = utils.getPrefix(customer.phone1);
                // tel =
                //   customer.phone1.indexOf("549") == 0
                //     ? customer.phone1.substr(3)
                //     : customer.phone1;
              }

              this.form.setFieldsValue({
                firstName: customer.firstName,
                lastName: customer.lastName,
                prefix: tel.prefix,
                tel: tel.phone
              });
              this.validatingUser = false;
              this.customerFieldsDisabled = true;
              this.subscriberId = customer.id;

              // if (customer.paymentCards.length > 0) {
              //   this.customerCards = customer.paymentCards;
              //   this.displayNewCardForm = false;
              //   this.displayCardSelect = true;
              //   this.cardFieldsDisabled = true;
              //   this.form.getFieldDecorator("customerCards", {
              //     initialValue: customer.paymentCards[0].id
              //   });
              //   this.cardSelectedId = customer.paymentCards[0].id;
              //   // window.setTimeout(() => {
              //   //   this.$nextTick(function() {
              //   //     this.$refs.cardSelect.$el.children[0].focus();
              //   //   });
              //   // }, 300);
              // } else {
              //no encontró tarjetas
              this.displayCardSelect = false;
              this.cardFieldsDisabled = false;
              this.displayNewCardForm = true;
              window.setTimeout(() => {
                this.$nextTick(function() {
                  this.$refs.paymentFormComponent.$refs.initial.$el.children[1].focus(); //focus en el número de tarjeta
                });
              }, 300);
              //}
            }
          } else throw new Error();
        }
      } catch (error) {
        console.log(error);
        this.form.resetFields([
          "firstName",
          "lastName",
          "tel",
          "cardNumber",
          "cardType",
          "cardName",
          "expirationDate",
          "CVC"
        ]);
        this.validatingUser = false;
        this.customerFieldsDisabled = false;
        this.displayCardSelect = false;
        this.cardFieldsDisabled = false;
        this.subscriberId = null;
        this.$nextTick(function() {
          this.$refs.firstName.$el.children[1].focus();
        });
      }
    },
    async handleSubmit(e) {
      let customerRes2;
      let payload;
      if (e) e.preventDefault();
      this.form.validateFields(async (error, formInput) => {
        let err;
        let x = 10;
        try {
          //validar que no haya error en el formulario. En caso de que sea un edit de tarjeta y el customer no tenga lastName guardar igual (los usuarios que se agregaron automaticamente desde el sistema de membresias no tienen last name y deben poder cambiar la tarjeta).
          if (!error || (!this.isAddSubscriber && error.lastName)) {
            this.submitLoader = true;
            //this.$refs.paymentFormComponent.enableSubmitLoader();
            //NOTA IMPORTANTE
            //el "try catch" tiene dos problemas:
            //1. no funciona de manera asyncrona por lo que no se pueden apilar varios awaits juntos con un solo catch, hay que poner uno por await call.
            //2. Axios (parece que por un CORS problem) tira error desconocido cada vez que el call no es un 200/201. Entonces la solución es configurarlo para que nunca tire error con los codigos 4xx y 5xx.

            //TEST
            /*
            customerRes2 = await Vue.prototype.$axios.post(`/customers`, {
              email: "lschnollEr@gmail.com",
              firstName: "first name",
              lastName: "lastname",
              phone1: "7483784378"
            });
            if (customerRes2.status != 201) {
              err = errors.handleHTTPError(customerRes2);
              throw err;
            }
            this.subscriberId = customerRes2.data.id;
            */

            //IF NOT ALREADY SAVED, SAVE CUSTOMER
            x = 10;
            x = 22;
            if (!this.subscriberId) {
              const y = 20;
              payload = {
                email: formInput.email,
                firstName: formInput.firstName,
                lastName: formInput.lastName,
                phone1: formInput.prefix + formInput.tel
              };
              this.subscriberId = await this.saveCustomer(payload);
            }

            console.log(this.subscriberId);
            this.$store.state.subscriber.customer = {
              id: this.subscriberId
            };

            //CREATE TEMP TOKEN
            //si es una tarjeta nueva se crea el token temporario para no enviar los datos completos de la tarjeta al servidor. Sino se envia directamente el id de tarjeta.
            let subscribePayload;
            let z = 14;
            if (!this.cardSelectedId) {
              // const tokenRes = await gateway.createTempToken(
              //   this.cardSelectedId,
              //   {
              //     cardName: formInput.cardName,
              //     cardNumber: formInput.cardNumber,
              //     expirationDate: formInput.expirationDate,
              //     CVC: formInput.CVC
              //   }
              // );
              // if (tokenRes.status != 201) {
              //   tokenRes.errorName = "DecidirGatewayError";
              //   err = errors.handleHTTPError(tokenRes);
              //   throw err;
              // }
              //const tempToken = tokenRes.data;
              z = 10;
              const card = await this.$refs.paymentFormComponent.handleSubmit();
              if (!card) throw new Error();

              subscribePayload = {
                tempToken: card.tempCardToken,
                paymentCourierId: card.paymentCourierId,
                cardBin: card.bin,
                lastFourDigits: card.lastFourDigits,
                cardSecurityCode: card.CVC,
                expirationDate: card.expirationDate,
                cardName: card.cardName,
                cardDNI: card.cardDNI
              };
            } else {
              subscribePayload = {
                paymentCardId: this.cardSelectedId
              };
            }
            // try {
            //SUBSCRIBE CUSTOMER AND SEND PAYMENT
            let subscribeRes;
            let description;
            //suscribe cliente, crea tarjeta y genera transacción de pago en el backend
            if (this.isAddSubscriber) {
              const x = 10;
              subscribeRes = await this.subscribe(subscribePayload);
              if (subscribeRes) description = "El cliente ha sido suscripto.";
            } else {
              //es un usuario existente que esta modificando lo datos de pago
              subscribeRes = await Vue.prototype.$axios.put(
                `/subscriptions/${this.subscription.id}/subscribers/${this.subscriberId}`,
                subscribePayload
              );
              const a = 10;
              let x = 10;
              let eirui = 239;
              if (subscribeRes.status != 200) {
                err = errors.handleHTTPError(subscribeRes);
                throw err;
              } else description = subscribeRes.data.message;
              // } else if (!this.subscriberActive)
              //   description = "Volvió a activarse la suscripción del cliente.";
              // else description = "Se registraron los nuevos datos de pago.";
            }
            this.submitLoader = false;
            this.displayNewCardForm = false;
            this.$store.commit("subscribers/SET_LIST_UPDATED", true);
            this.$notification["success"]({
              message: "Exito",
              description
            });
            if (this.isAddSubscriber) this.backButton();
            else
              await this.loadCustomer(
                this.$route.params.subscriberId,
                this.subscriptionId
              );
          } else {
            const x = 10;
            throw new Error("Error de validación de datos.");
          }
        } catch (err) {
          console.log(err);
          this.submitLoader = false;
          this.switchLoader = false;
          let description;
          if (this.isAddSubscriber) {
            if (err.message) description = err.message;
            else
              description =
                "Error al suscribir el cliente. Por favor, intente denuevo.";

            this.$notification["warning"]({
              message: "Error",
              description: description
            });
          } else {
            if (err.message) description = err.message;
            else
              description =
                "Error al editar la forma de pago. Por favor, intente denuevo.";

            this.$notification["warning"]({
              message: "Error",
              description: description
            });
          }
        }
        //} else {
        //  console.log("error", error);
        //  throw new Error("Error de validación de datos.");
        //err.formError = error;
        //throw err;
        //}
      });
    },
    cardNameHelper() {
      if (
        this.form.getFieldValue("cardName") == undefined &&
        this.form.getFieldValue("firstName") != undefined &&
        this.form.getFieldValue("lastName") != undefined
      )
        this.form.setFieldsValue({
          cardName: `${this.form.getFieldValue(
            "firstName"
          )} ${this.form.getFieldValue("lastName")}`
        });
    },
    formatCardNumber(e) {
      //e.data es el caracter que ingresó el usuario y e.target.value es todo
      //el string del input. Si no es un numero remover el caracter del input con slice
      //sino dejar el valor de todo el input
      let val = isNaN(e.data) ? e.target.value.slice(0, -1) : e.target.value;
      val = val.split(" ").join(""); // remover espacios
      if (val.length > 0) {
        val = val.match(new RegExp(".{1,4}", "g")).join(" ");
      }
      return val;
    },
    handleRoute() {
      if (this.$route.name == "subscriberAdd") {
        this.isAddSubscriber = true;
        this.switchDisabled = true;
        this.displayClientInfo = false;
      } else if (this.$route.name == "subscriberEdit") {
        this.isAddSubscriber = false;
        this.displayClientInfo = true;
      } else if (this.$route.name == "subscriberView") {
        this.isAddSubscriber = false;
        this.displayClientInfo = true;
      }
    }
  },
  mounted() {
    this.handleRoute();
    this.fetchSubscription();
  },
  watch: {
    //REACTIVE TO URL CHANGE
    $route(to) {
      this.handleRoute();
    }
  }
};
</script>

<style lang="scss" module>
@import "./index.module.scss";
</style>

<style lang="css">
h3 {
  font-size: 1.2rem;
}
.ant-card {
  border-radius: 7px;
}
.ant-card-head-title {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 2rem;
}
.ant-card-body {
  padding-bottom: 9px;
}
.ant-form-item-control-wrapper {
  /*white-space: nowrap;*/
}
.ant-select-selection-selected-value {
  padding-right: 1px;
}
.back-button {
  /*background-color: #fff;
  border-color: #777;
  color: #777;*/
  vertical-align: 0.38rem;
}
.back-button .anticon {
  vertical-align: -0.213rem;
}
.ant-collapse-item {
  border-bottom: none !important;
}
.add-form {
  width: 30rem;
}
.tooltip-icon {
  color: #ccc;
  margin-left: 0.5rem;
}
.tooltip-top {
  position: absolute;
  top: 2px;
  right: -19px;
}
@media (max-width: 767px) {
  .ant-card-head-wrapper {
    flex-direction: column-reverse !important;
    align-items: flex-start;
  }
  .ant-card-head-title {
    flex-grow: 5;
    /*font-size: 100%;*/
    width: 25rem;
  }
  .ant-card-extra {
    float: inherit !important;
    margin-left: inherit !important;
    align-self: flex-end;
  }
  .add-form {
    width: inherit;
  }
  .ant-switch {
    margin-left: 0 !important;
  }
  .title-id {
    display: none;
  }
  .hover-title {
    font-size: 1.7rem;
    letter-spacing: -1px;
  }
  .hover-title + .edit-icon {
    display: inline;
  }
  .edit-subscription-button {
    display: inline !important;
  }
}
.edit-subscription-button {
  display: none;
}
.edit-icon {
  display: none;
}
.hover-title {
  cursor: pointer;
}
.hover-title:hover + .edit-icon {
  display: inline;
}
</style>
